import { FC } from 'react';

import DataTablePagination from 'modules/_shared/components/Tables/DataTablePagination';

import { useReclassificationModal } from '../context/ReclassificationModalContext';
import RangeRow from './RangeRow';

const RangesView: FC = () => {
  const { data, actions } = useReclassificationModal();

  const hasData = data.ranges && data.ranges.length > 0;

  return (
    <>
      {data.ranges.map((range, index) => (
        <div className="form-control-wrap" key={`row-${range.key}`}>
          <RangeRow index={index} range={range} />
        </div>
      ))}

      {hasData && (
        <div className="mt-1">
          <DataTablePagination
            itemPerPage={data.rowsPerPage || 10}
            totalItems={data.totalRanges || 0}
            paginate={actions.handleChangePage}
            currentPage={data.page}
            onChangeRowsPerPage={actions.handleChangeRowsPerPage}
            customItemPerPage={0}
            setRowsPerPage={() => {}}
          />
        </div>
      )}
    </>
  );
};

export default RangesView;
